<template>
  <router-view></router-view>
</template>
<script>
var DOMAIN = 'https://artofcast.localhost';

// console.log(window.location.hostname)
if (window.location.hostname != '192.168.0.108' && window.location.hostname != 'localhost') {
  DOMAIN = '';
}


export default {

  provide() {
    return {
      URL_PAYMENT: DOMAIN + '/v1/api/payment',
      URL_GET: DOMAIN + '/v1/api/get',
      URL_BOOKING: DOMAIN + '/v1/api/booking',
      URL_CANCEL: DOMAIN + '/v1/api/cancel',
      URL_CHANGE_BOOKINGS: DOMAIN + '/v1/api/changebookings',
      URL_MYBOOKING: DOMAIN + '/v1/api/mybooking',
      URL_SENDCOMMENT: DOMAIN + '/v1/api/addcomment',
      URL_SENDMODE: DOMAIN + '/v1/api/schedulemode',
      URL_SETNOTIFY: DOMAIN + '/v1/api/setnotify',
      URL_SETNOTIFY_TELEGRAM: DOMAIN + '/v1/api/setnotifytg',
      URL_GETOFFICE: DOMAIN + '/v1/api/getuseroffice',
      URL_SET_MEMORY_BOOKINGS: DOMAIN + '/v1/api/setmemorybookings'
    }
  },

}
</script>
